export default (nodeA, nodeB) => nodeA.position[0] < nodeB.position[0] || nodeA.position[1] < nodeB.position[1];